import assertNever from "assert-never";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { ItemStatus } from "../../TrainingCenter/TrainingCenterUtils";

interface Props {
  status: ItemStatus;
}

const TrainingCenterBundleItemCardStatus = (props: Props) => {
  switch (props.status) {
    case ItemStatus.COMPLETE:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="completed">
          {translate(STRINGS.COMPLETED)}
        </div>
      );
    case ItemStatus.EXEMPT:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="exempt">
          {translate(STRINGS.EXEMPTED)}
        </div>
      );

    case ItemStatus.LOCKED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="locked">
          {translate(STRINGS.LOCKED)}
        </div>
      );
    case ItemStatus.SIGNATURE_REQUIRED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="signature-required">
          {translate(STRINGS.SIGNATURE_REQUIRED)}
        </div>
      );
    case ItemStatus.SUBMIT_REQUIRED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="submit-required">
          {translate(STRINGS.SUBMIT_REQUIRED)}
        </div>
      );
    case ItemStatus.TEST_FAILED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="test-failed">
          {translate(STRINGS.TEST_FAILED)}
        </div>
      );
    case ItemStatus.TEST_REQUIRED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="test-failed">
          {translate(STRINGS.TEST_REQUIRED)}
        </div>
      );

    case ItemStatus.WATCH_REQUIRED:
      return (
        <div className="TrainingCenterBundleItemCardStatus" data-status="watch-required">
          {translate(STRINGS.WATCH_REQUIRED)}
        </div>
      );
    default:
      assertNever(props.status);
  }
};

export default TrainingCenterBundleItemCardStatus;
